<template>
  <div class="targetSplit">
      <div class="list" v-show="dataList.length>0" >
        <div class="addGengai">
          <div class="addTarget">
            <div @click="addTarget">+ 添加新目标拆分</div>
          </div>
          <table>
            <tbody>
              <tr>
                <th>序号</th>
                <th>学期</th>
                <th>目标制定日期</th>
                <th>操作</th>
              </tr>
              <tr v-for="(item,index) in dataList" :key="index">
                <td>{{index+1}}</td>
                <td>{{item.name}}</td>
                <td>{{item.createdAt}}</td>
                <td>
                  <span class="activeShow"
                        @click="$router.push({
                          path:'/consultant/minestudent/main/implement/targetsplit/show',
                          query:{...$route.query,targetId:item.id}

                        })">查看</span>
                  <span class="getActive" :style="{color:item.name.indexOf(name)==-1?'rgb(204, 204, 204)':''}"
                      @click="update(item)">更新</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <Pages :page-data="options" :change="list"></Pages>
      </div>
      <div v-show="dataList.length==0" class="list">
        <Add  name="暂无数据!" :path="{path:'/consultant/minestudent/main/implement/targetsplit/add',query:$route.query}"></Add>
      </div>
  </div>
</template>

<script>
import Pages from '@/components/assembly/Pagination';
import Add from '@/components/xueyezixun/Add.vue'
export default {
  name: "list",
  components:{Add,Pages},
  data(){
    return{
      dataList:[],
      studentId:window.sessionStorage.getItem('studentId'),
      title:['序号','学期','目标制定日期','操作'],
      keys:['xuhao','name','createdAt',null],
      options:{
        current:1,
        total:0,
        pageSize:10,
        totalPage:1
      },
      name:'',
      bool:false
    }
  },
  methods:{
    list(pageNumber,pageSize){
      this.$ajax.post(this.G_acapi+ this.ports.consultant.student.mine.implement.chaifenList, {
          studentId:sessionStorage.getItem("myStudentStudentId"),
          pageNumber:pageNumber||this.options.current,
          pageSize:pageSize||this.options.pageSize
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then((res) => {
        if (res.data.code == 2000) {
          this.dataList = res.data.data.list;
          this.options.total=res.data.data.page.count;
          this.options.totalPage=res.data.data.page.totalPage;
          this.$ajax.post(this.G_acapi+ this.ports.consultant.student.mine.implement.chaifenNow, {
            studentId:sessionStorage.getItem("myStudentStudentId"),
          }, {
            headers: {
              token: window.sessionStorage.getItem('ymtxToken')
            }
          }).then((res) => {
            if (res.data.code == 2000) {
              this.name=res.data.data.name;
              this.bool=res.data.data.isStore==1?false:true
              

            }else{

            }
          })

        }else{

        }
      })
    },
    addTarget(){
      if(this.bool){
        this.$router.push({path:'/consultant/minestudent/main/implement/targetsplit/add',query:this.$route.query})
      }else{
        this.$message.error('当前学期只能添加一次目标拆分，可对当前学期目标进行更新')
      }
    },
    update(item){
      if(item.name.indexOf(this.name)==-1){
        return
      }else{
        this.$router.push({
          path:'/consultant/minestudent/main/implement/targetsplit/update',
          query:{...this.$route.query,targetId:item.id}
        })
      }
    }
  },
  mounted() {
    this.list()
  }
}
</script>

<style scoped lang="less">
  table{
    width: 100%;
    border-collapse: collapse;
    background: #fff;
    tbody{
      width: 100%;
    }
    tr{
      width: 100%;
      line-height: 40px;
      border-radius: 5px;
      border-bottom: 1px solid #ECECEC;
    }
    th{
      font-size: 16px !important;
      background: rgba(61, 144, 246, 0.1);
    }
    td,th{
      text-align: center;
      font-size: 14px;
      span{
        color: #1EA1EE;
        cursor: pointer
      }
    }
  }
  @import "./css/index.less";
</style>